export const SessionDetailsMap = {
  loginId: 'Login Id',
  flinksRequestId: 'Flinks Request Id',
  inveriteId: 'Inverite Id',
};

export default SessionDetailsMap;
